/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  AtomicBlockUtils,
  ContentBlock,
  convertFromRaw,
  convertToRaw,
  DraftBlockType,
  DraftHandleValue,
  EditorState,
  getDefaultKeyBinding,
  RichUtils,
} from "draft-js";
import Editor from "@draft-js-plugins/editor";
import createImagePlugin from "@draft-js-plugins/image";
const imagePlugin = createImagePlugin({
  imageComponent: ImageComponentBlock,
});
import React, { useEffect, useState } from "react";
import { IGrape } from "../grape_gql_interface";

import { Box, CircularProgress } from "@material-ui/core";
import { IGrapeDetailAction } from "./GrapeDetail";
import DetailScaffold from "./DetailScaffold";
import Grapes from "../../modules/Grapes";
import { useApolloClient } from "@apollo/react-hooks";
import MLDialog from "../MLDialog";
import { __DEV__ } from "../../utils/init";
import { IGrapeFile } from "../GrapeFile";
import { ImageComponentBlock } from "./components/ImageComponentBlock";
import useSocket from "../../hooks/useSocket";

// import * as j from "jsondiffpatch";
import { create } from "jsondiffpatch";
import { GrapeDetailToolbar } from "./GrapeDetail/GrapeDetailToolbar";
const j = create({
  objectHash: function (obj: any, index: any) {
    return obj.key || "$$index:" + index;
  },
});

interface IRichTextGrape {
  editGrape: (grapeId: string, prop: string, value: any, props?: any) => void;
  renderGrapesColumn: (child: IGrape, children: IGrape[]) => any;
  grape: IGrape;
  childrens: IGrape[];
}

function parseInitialRTEValue(value: string) {
  let parsed;
  try {
    if (value) {
      let str = JSON.parse(value || "");
      parsed = EditorState.createWithContent(convertFromRaw(str));
      if (parsed) return parsed;
    }
  } catch (e) {
    console.log("❌ error parsing:", value, "❌", e);
  }
  return EditorState.createEmpty();
}

const RichTextGrape = (props: IRichTextGrape) => {
  const client = useApolloClient();
  const { renderGrapesColumn, editGrape, childrens, grape } = props;
  const [uploadFiles, setUploadFiles] = useState<string[]>([]);

  const [editorState, _onChange] = useState(parseInitialRTEValue(grape.description));

  const debounceRef = React.useRef<any>(null);

  useEffect(() => {
    // console.log(grape.description === props.grape.description ? "🟩" : "🟥");
    dispatchDifferences(grape, props.grape);

    /*
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      const nextEditorState = parseInitialRTEValue(props.grape.description);

      const str1 = JSON.stringify(convertToRaw(nextEditorState.getCurrentContent()));
      const str2 = JSON.stringify(convertToRaw(editorState.getCurrentContent()));

      const delta = JSON.parse(str1);
      let raw = JSON.parse(str2);
      console.log(123, raw, delta, str1 === str2);

      const b = j.patch(raw, delta);
      console.log("s2", b);

      // const a = { a: 1, b: 2, c: 1 };
      // const b = { a: 1, b: 3, c: 1 };
      // console.log("s1", a, b);
      // const xb = j.patch(a, b);
      // console.log("s2", xb, a, b);

      // let nextContentState = convertFromRaw(j.patch(raw, delta));
      // console.log(999999999, nextContentState);

      //@ts-ignore
      // onChange(EditorState.push(editorState, nextContentState));
    }, 500);
    */
  }, [props.grape]);

  const dispatchDifferences = (prev: IGrape, next: IGrape) => {
    // console.log(1, prev.description, next.description);
    // if (prev.description === next.description) return;
    // console.log(2);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      try {
        const nextEditorState = parseInitialRTEValue(next.description);

        // const delta = nextEditorState.getCurrentContent();
        // let raw = convertToRaw(editorState.getCurrentContent());
        // let nextContentState = convertFromRaw(j.patch(raw, delta));

        // console.log(999999999, nextContentState);

        // //@ts-ignore
        // onChange(EditorState.push(editorState, nextContentState));

        // _onChange(nextEditorState);//TODO
        // const differences = getEditorStateDifferences(editorState, nextEditorState);
      } catch (e) {
        console.log("catch err");
      }
    }, 500);
  };

  const getEditorStateDifferences = (prev: EditorState, next: EditorState) => {
    const prevList = prev.getCurrentContent().getBlocksAsArray();
    const nextList = next.getCurrentContent().getBlocksAsArray();

    for (let i in prevList) {
      const prevBlock = prevList[i];
      for (let j in nextList) {
        const nextBlock = nextList[j];
        console.log(prevBlock.getKey(), nextBlock.getKey());

        // if (prevBlock.key === nextBlock.key) {
        //   if (prevBlock.text !== nextBlock.text) {
        //     console.log("text changed", prevBlock.text, nextBlock.text);
        //   }
        // }
      }
    }

    console.log(prevList.length, nextList.length);
  };

  // const rteSocket = useSocket("updatedGrape", (read: any) => {
  //   console.log(123, read);
  // });

  // const rteSockedBroadcast = (data: any) => {
  //   if (debounceRef.current) clearTimeout(debounceRef.current);
  //   debounceRef.current = setTimeout(() => {
  //     rteSocket.emit("updatedGrape", {
  //       grapeId: grape.id,
  //       data: JSON.stringify({
  //         raw: convertToRaw(editorState.getCurrentContent()),
  //       }),
  //     });
  //     console.log("emitted", data);
  //   }, 300);
  // };

  const onChange = (newEditorState: EditorState) => {
    _onChange(newEditorState);

    // rteSockedBroadcast(newEditorState);

    // console.log(1)
    // const textStr = newEditorState.getCurrentContent().getPlainText();
    const textStr = JSON.stringify(convertToRaw(newEditorState.getCurrentContent()));
    editGrape(grape.id, "description", textStr, { withDelay: true });
    // console.log(2)
  };

  const handleKeyCommand = (command: string, editorState: EditorState, timestamp: number) => {
    const newState = RichUtils.handleKeyCommand(editorState, command);
    if (newState) {
      onChange(newState);
      return "handled";
    }
    return "not-handled";
  };

  const insertImage = (editorState: EditorState, gFile: IGrapeFile) => {
    // const dad =
    //   "data:image/png;base64,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";
    // console.log("-->", base64orURL);
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity("image", "IMMUTABLE", { ...gFile, src: gFile.url });
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    const newEditorState = EditorState.set(editorState, {
      currentContent: contentStateWithEntity,
    });
    return AtomicBlockUtils.insertAtomicBlock(newEditorState, entityKey, " ");
  };

  const handlePastedFiles = (files: Blob[]): DraftHandleValue => {
    let handled = false;
    files.forEach((blob, index) => {
      if (["image/png", "image/jpeg", "image/gif"].includes(blob.type)) {
        // const name = (blob as any).name || "file-" + new Date().getTime() + ".jpeg";
        const name = `rte-image-${new Date().getTime()}_${index}.jpeg`;
        const file = new File([blob], name);
        setUploadFiles((files) => [...files, name]);
        Grapes.startFileUpload(client, grape.id, file, name)
          .then((r) => {
            setUploadFiles((files) => files.filter((n) => n !== name));
            if (__DEV__) console.log("🟩 uploaded ", r);
            const grapeFile: IGrapeFile = (r?.data?.uploadFile?.files || []).filter(
              (n: IGrapeFile) => n?.title === name
            )[0];
            if (grapeFile) {
              if (__DEV__) console.log("display", grapeFile);
              const newEditorState = insertImage(editorState, grapeFile);
              onChange(newEditorState);
            }
          })
          .catch((e) => {
            setUploadFiles((files) => files.filter((n) => n !== name));
            MLDialog.showSnackbar("❌ err uploading file");
            console.log("❌ file ", e);
          });
      }
    });
    return handled ? "handled" : "not-handled";

    // let handled = false;
    // files.forEach((file) => {
    //   if (["image/png", "image/jpeg", "image/gif"].includes(file.type)) {
    //     insertBlob(file);
    // const insertBlob = (blob: Blob) => {
    //   var reader = new FileReader();
    //   reader.readAsDataURL(blob);
    //   reader.onloadend = function () {
    //     var base64data = reader.result;
    //     console.log(base64data);
    //   };
    // };
    //   }
    // });
    // return handled ? "handled" : "not-handled";
  };

  const onShortcutHeader = (direction: "bigger" | "smaller") => {
    const hLevels = [
      "unstyled",
      // "header-six",
      // "header-five",
      "header-four",
      "header-three",
      "header-two",
      "header-one",
    ];
    let current = RichUtils.getCurrentBlockType(editorState);
    if (!hLevels.includes(current)) current = hLevels[0];

    if (hLevels[0] === current && direction === "smaller") return;
    if (hLevels[hLevels.length - 1] === current && direction === "bigger") return;

    const newLevel = hLevels[hLevels.indexOf(current) + (direction === "bigger" ? 1 : -1)];
    onChange(RichUtils.toggleBlockType(editorState, newLevel));
  };

  const mapKeyToEditorCommand = (e: React.KeyboardEvent<{}>) => {
    if (e.ctrlKey) {
      if (e.code == "ArrowUp") {
        onShortcutHeader("bigger");
        return;
      }
      if (e.code == "ArrowDown") {
        onShortcutHeader("smaller");
        return;
      }
    }

    if (e.keyCode === 9 /* TAB */) {
      const newEditorState = RichUtils.onTab(e, editorState, 4 /* maxDepth */);
      if (newEditorState !== editorState) {
        onChange(newEditorState);
      }
      return null;
    }
    return getDefaultKeyBinding(e);
  };

  const toggleBlockType = (blockType: DraftBlockType) => {
    onChange(RichUtils.toggleBlockType(editorState, blockType));
  };

  const toggleInlineStyle = (inlineStyle: string) => {
    onChange(RichUtils.toggleInlineStyle(editorState, inlineStyle));
  };

  const outerPadding = 10;

  return (
    <DetailScaffold grape={props.grape} header={<GrapeDetailToolbar />}>
      <Box flexGrow={1} display="flex" flexDirection="column" css={rteStyle}>
        <div style={{ padding: outerPadding }}>
          <BlockStyleControls editorState={editorState} onToggle={toggleBlockType} />
          <InlineStyleControls editorState={editorState} onToggle={toggleInlineStyle} />
        </div>

        <Box
          flexGrow={1}
          style={{ position: "relative" }}
          css={{
            padding: outerPadding,
            paddingBottom: 0,
            ".DraftEditor-root": { height: "100%" },
            ".DraftEditor-editorContainer": { height: "100%" },
            ".public-DraftEditor-content": { height: "100%" },
            //---
            ".public-DraftEditorPlaceholder-inner": { position: "absolute", opacity: 0.4, pointerEvents: "none" },
          }}
        >
          <Editor
            editorState={editorState}
            blockStyleFn={getBlockStyle}
            customStyleMap={styleMap}
            handleKeyCommand={handleKeyCommand}
            handlePastedFiles={handlePastedFiles}
            blockRendererFn={blockRenderFn}
            keyBindingFn={mapKeyToEditorCommand}
            onChange={onChange}
            placeholder="Write here..."
            spellCheck={true}
            plugins={[imagePlugin]}
          />
        </Box>
      </Box>

      {uploadFiles.length ? (
        <div
          style={{
            position: "absolute",
            zIndex: 10,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            backdropFilter: "blur(2px)",
          }}
          onClick={(e) => e.preventDefault()}
          onPointerDown={(e) => e.preventDefault()}
        >
          <CircularProgress size={48} />
        </div>
      ) : null}
    </DetailScaffold>
  );

  function blockRenderFn(contentBlock: ContentBlock) {
    if (contentBlock.getType() === "atomic") {
      const contentState = editorState.getCurrentContent();
      const entity = contentState.getEntity(contentBlock.getEntityAt(0));

      if (entity && entity.getType() === "image") {
        return {
          component: ImageComponentBlock,
          editable: false,
        };
      }

      // //? EMBEDDED LINK - VIMEO / YOUTUBE
      // if (entity && entity.getType() === "EMBEDDED_LINK") {
      //   return {
      //     component: EmbeddedLink,
      //     editable: false
      //   };
      // }

      // //? UPLOAD FILE AREA
      // if (entity && entity.getType() === uploadFileAreaKey) {
      //   return {
      //     component: FileAreaUpload,
      //     // component: props.withFileArea ? FileAreaUpload : () => null,
      //     editable: false,
      //     props: {
      //       disabled: props.disableFileArea || !props.readOnly,
      //       onAcceptedFiles: props.onAcceptedFiles,
      //       onDeletedFile: props.onDeletedFile,
      //       fileInteractions: props.fileInteractions,
      //       sprintInteraction: props.sprintInteraction
      //     }
      //   };
      // }
    }
  }
};

export default RichTextGrape;

// Custom overrides for "code" style.
const styleMap = {
  CODE: {
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
    fontSize: 16,
    padding: 2,
  },
};

const getBlockStyle = (block: any) => {
  switch (block.getType()) {
    case "blockquote":
      return "RichEditor-blockquote";
    default:
      return "";
  }
};

const StyleButton = (props: { active: boolean; label: string; style: string; onToggle: (style: string) => void }) => {
  const onToggle = (e: any) => {
    e.preventDefault();
    props.onToggle(props.style);
  };

  let className = "RichEditor-styleButton";
  if (props.active) {
    className += " RichEditor-activeButton";
  }

  return (
    <span className={className} onMouseDown={onToggle}>
      {props.label}
    </span>
  );
};

const BLOCK_TYPES = [
  { label: "H1", style: "header-one" },
  { label: "H2", style: "header-two" },
  { label: "H3", style: "header-three" },
  { label: "H4", style: "header-four" },
  { label: "H5", style: "header-five" },
  { label: "H6", style: "header-six" },
  { label: "Blockquote", style: "blockquote" },
  { label: "UL", style: "unordered-list-item" },
  { label: "OL", style: "ordered-list-item" },
  { label: "Code Block", style: "code-block" },
];

const BlockStyleControls = (props: { editorState: EditorState; onToggle: (style: string) => void }) => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();

  return (
    <div className="RichEditor-controls">
      {BLOCK_TYPES.map((type) => (
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};

var INLINE_STYLES = [
  { label: "Bold", style: "BOLD" },
  { label: "Italic", style: "ITALIC" },
  { label: "Underline", style: "UNDERLINE" },
  { label: "Monospace", style: "CODE" },
];

const InlineStyleControls = (props: { editorState: EditorState; onToggle: (style: string) => void }) => {
  const currentStyle = props.editorState.getCurrentInlineStyle();

  return (
    <div className="RichEditor-controls">
      {INLINE_STYLES.map((type) => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
        />
      ))}
    </div>
  );
};

const rteStyle = css`
  .RichEditor-root {
    background: #fff;
    border: 1px solid #ddd;
    font-family: "Georgia", serif;
    font-size: 14px;
    padding: 15px;
  }

  .RichEditor-editor {
    border-top: 1px solid #ddd;
    cursor: text;
    font-size: 16px;
    margin-top: 10px;
  }

  .RichEditor-editor .public-DraftEditorPlaceholder-root,
  .RichEditor-editor .public-DraftEditor-content {
    margin: 0 -15px -15px;
    padding: 15px;
  }

  .RichEditor-editor .public-DraftEditor-content {
    min-height: 100px;
  }

  .RichEditor-hidePlaceholder .public-DraftEditorPlaceholder-root {
    display: none;
  }

  .RichEditor-editor .RichEditor-blockquote {
    border-left: 5px solid #eee;
    color: #666;
    font-family: "Hoefler Text", "Georgia", serif;
    font-style: italic;
    margin: 16px 0;
    padding: 10px 20px;
  }

  .RichEditor-editor .public-DraftStyleDefault-pre {
    background-color: rgba(0, 0, 0, 0.05);
    font-family: "Inconsolata", "Menlo", "Consolas", monospace;
    font-size: 16px;
    padding: 20px;
  }

  .RichEditor-controls {
    font-family: "Helvetica", sans-serif;
    font-size: 14px;
    margin-bottom: 5px;
    user-select: none;
  }

  .RichEditor-styleButton {
    color: #999;
    cursor: pointer;
    margin-right: 16px;
    padding: 2px 0;
    display: inline-block;
  }

  .RichEditor-activeButton {
    color: #5890ff;
  }

  .DraftEditor-root figure {
    margin: 0;
    img: {
      width: 100%;
    }
  }

  .DraftEditor-root figure img {
    max-width: 100%;
  }
`;
